module.exports = __webpack_public_path__ + "e71b678a99.woff2";